<div
  id="breadcrumb"
  class="breadcrumb d-flex gap-2 hidden-breadcrumb"
  aria-hidden="true"
>
  <ng-container *ngFor="let item of breadcrumbItems; let isLast = last">
    <a
      *ngIf="!isLast; else last"
      class="breadcrumb-item"
      [routerLink]="item.path"
      [queryParams]="item.queryParams"
      >{{ item.title | translate }}</a
    >
    <ng-template #last>
      <span>{{ item.title | translate }}</span>
    </ng-template>
    <span *ngIf="!isLast" class="arrow">
      {{ ">" }}
    </span>
  </ng-container>
</div>

<div
  class="breadcrumb d-flex gap-2"
  *ngIf="showBread === 'NORMAL'"
  [class.on-card]="contentOnCard"
>
  <ng-container *ngFor="let item of breadcrumbItems; let isLast = last">
    <a
      *ngIf="!isLast; else last"
      class="breadcrumb-item"
      [routerLink]="item.path"
      [queryParams]="item.queryParams"
      >{{ item.title | translate }}</a
    >
    <ng-template #last>
      <span>{{ item.title | translate }}</span>
    </ng-template>
    <span *ngIf="!isLast" class="arrow">
      {{ ">" }}
    </span>
  </ng-container>
</div>

<div
  class="breadcrumb d-flex gap-2"
  *ngIf="showBread === 'MOBILE'"
  [class.on-card]="contentOnCard"
>
  <ng-container [ngSwitch]="breadcrumbItems.length">
    <ng-container *ngSwitchCase="1"
      ><span>{{ breadcrumbItems[0].title | translate }}</span>
    </ng-container>
    <ng-container *ngSwitchCase="2">
      <a
        class="breadcrumb-item"
        [routerLink]="breadcrumbItems[0].path"
        [queryParams]="breadcrumbItems[0].queryParams"
        >{{ breadcrumbItems[0].title | translate }}</a
      >
      <span class="arrow">{{ ">" }}</span>
      <span>{{ breadcrumbItems[1].title | translate }}</span>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <a
        class="breadcrumb-item"
        [routerLink]="breadcrumbItems[0].path"
        [queryParams]="breadcrumbItems[0].queryParams"
        >{{ breadcrumbItems[0].title | translate }}</a
      >
      <span class="arrow">{{ ">" }}</span>
      <div>
        <span
          class="inner-items-opener breadcrumb-item"
          (click)="isInnerItemsOpened = !isInnerItemsOpened"
          #innerItemsOpener
          >{{ "..." }}</span
        >
        <div
          class="flex-column gap-1 inner-items-container"
          [ngStyle]="{ display: isInnerItemsOpened ? 'flex' : 'none' }"
        >
          <a
            *ngFor="
              let innerItem of breadcrumbItems
                | slice: 1:breadcrumbItems.length - 1
            "
            class="inner-item breadcrumb-item"
            [routerLink]="innerItem.path"
            [queryParams]="innerItem.queryParams"
            >{{ innerItem.title | translate }}</a
          >
        </div>
      </div>
      <span class="arrow">{{ ">" }}</span>
      <span>
        {{ breadcrumbItems[breadcrumbItems.length - 1].title | translate }}
      </span>
    </ng-container>
  </ng-container>
</div>
